import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Card, Input, Logo } from "@wmart/ui";
import { api, ApiError } from "../lib/api-client.js";

const PASSWORD_MIN = 8;

export function PasswordResetConfirm() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!token) {
      setError("Reset link is missing a token.");
      return;
    }
    if (password.length < PASSWORD_MIN) {
      setError(`Password must be at least ${PASSWORD_MIN} characters.`);
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setBusy(true);
    setError(null);
    try {
      await api.post("/v1/auth/password/reset/confirm", {
        token,
        new_password: password,
      });
      navigate("/login?reset=1", { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 400) {
        setError("This reset link is invalid or has expired.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-paper-warm p-4">
      <Card className="w-full max-w-md p-8">
        <div className="flex flex-col items-center gap-4">
          <Logo size="lg" />
          <h1 className="font-serif text-display-sm text-ink-900">
            Set admin password
          </h1>
        </div>
        <form onSubmit={onSubmit} className="mt-8 flex flex-col gap-4">
          <Input
            type="password"
            label="New password"
            required
            minLength={PASSWORD_MIN}
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Input
            type="password"
            label="Confirm new password"
            required
            minLength={PASSWORD_MIN}
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            {...(error ? { error } : {})}
          />
          <Button type="submit" full disabled={busy} loading={busy}>
            Set password
          </Button>
        </form>
      </Card>
    </main>
  );
}